const getPepReferralClinics = async () => {
  const result = await fetch('/api/pep-referral-clinics')
  const parsed = await result.json()

  if (result.status !== 200) return Promise.reject(parsed)

  const { pepReferralClinics } = parsed

  return {
    context: {
      pepReferralClinics,
    },
  }
}

export default getPepReferralClinics
